module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-tilt-machine-04.62f8335c.jpg";